import Vue from "vue";
import moment from "moment";
import { getLocale } from "@/app/shared/services/i18n/index.js";
import i18n from "@/plugins/vue-i18n";
const RELATIVE_FORMAT_DAYS_DIFF = 8;

// TODO dep: Theme Service | get formats from theme service
/**
 * @hasTime - added to remove time from relative dates in @notifications
 */

export function formatDateFunction(date, type = "datetime", hasTime=true, locale = getLocale(), defaultErrMsg) {
  if(!isNaN(date)) date = Number(date);
  // date = 1671702015000;
  let dateFormat = "ll"; // MMM Do YYYY
  let timeFormat = "HH:mm";
  let format = String;
  let localDate = moment(date).local();
  // let localDate = moment.tz(date, currentUserTimeZone);
  const daysFromNow = getDiffInDaysFromNow(localDate);
  let humDate = ""; //days ago

  switch (type) {
    case "date":
      format = dateFormat;
      break;
    case "time":
      format = timeFormat;
      break;
    case "short":
      if (moment().isSame(moment(date), "d")) {
        format = "HH:mm";
      } else if (moment().isSame(moment(date), "w")) {
        format = "ddd";
      } else {
        format = "l";
      }
      break;
    case "humanize":
      format = "HH:mm";
      if(daysFromNow < 1) {
        format = timeFormat;
        humDate = ` (${localDate.locale(locale).fromNow()})`;
      } else {
        format = dateFormat;
        if (daysFromNow < RELATIVE_FORMAT_DAYS_DIFF) {
          humDate = ` (${i18n.tc("TimeDaysAgo", daysFromNow)})`;
        }
      }
      break;
    case "relative":
    // shows relative time, e.g. "2 days ago", instead of exact date of last contact
      if (daysFromNow < RELATIVE_FORMAT_DAYS_DIFF) {
        return localDate.locale(locale).fromNow();
      }
    /* falls through */
    default:
      if(hasTime) {
        format = `${dateFormat}, ${timeFormat}`; // MMM Do YYYY, HH:mm
      } else {
        format = `${dateFormat}`; // MMM Do YYYY
      }
      break;
  }

  if(!moment(date).isValid() && !!defaultErrMsg) {
    return defaultErrMsg;
  }
  return `${ moment(date).locale(locale).local().format(format)}${humDate}`;
}

// moment закръгля на часове. Така днес в 10ч тикетът от снощи в 23ч ще го пише "преди 11 часа", а ние искаме да пише "вчера"
// затова имаме custom
const getDiffInDaysFromNow = (prevMoment) => {
  const startOfToday = moment().local().startOf("day");
  const startOfDayOfPrevMoment = moment(prevMoment).startOf("day");
  return startOfToday.diff(startOfDayOfPrevMoment, "days");
};

Vue.filter("formatDate", formatDateFunction);
